import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Dayjs } from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import { Constants } from '../../../../utilities/constants';
import { AssigneeAutocomplete } from '../../AssigneeAutocomplete/AssigneeAutocomplete';
import CustomAutocomplete from '../../CustomAutocomplete/CustomAutocomplete';
import CustomButton from '../../CustomButton/CustomButton';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import CustomDragnDrop from '../../CustomDragnDrop/CustomDragnDrop';
import CustomTextField from '../../CustomTextField/CustomTextField';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';
import styles from './CustomAddTaskForm.module.css';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
    },
  },
};

const isAssigneeError = (message: string) => /\bassign(?:ee|ed|ment| to)?\b/i.test(message);

const CustomAddTaskForm = ({
  subtask,

  handleEmailChange,
  handleEmailBlur,
  email,
  invalidEmail,
  didEmailChange,

  handleRateChange,
  handleRateBlur,
  rate,
  invalidRate,
  didRateChange,
  handleQTYChange,
  handleQTYBlur,
  qTY,
  invalidQTY,
  didQTYChange,
  handleCommentChange,
  handleCommentBlur,
  comment,
  invalidComment,
  didCommentChange,
  handleLinkChange,
  handleLinkBlur,
  link,
  invalidLink,
  didLinkChange,
  handleSubjectChange,
  handleSubjectBlur,
  subject,
  invalidSubject,
  didSubjectChange,
  error,
  Priority,
  selectedItems,
  handleDeleteItems,
  handleSelection,
  onDrop,
  selectedFiles,
  add,
  deleteFile,
  selectedType,

  date,
  setDate,
  Status,

  edit,
  relatedTo,
  name,
  formLoading,
  onClearError,
}: {
  subtask: boolean;
  OnClickSubtask: () => void;
  handleTermsChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleTermsBlur?: () => void;
  terms?: string;
  invalidTerms?: boolean;
  didTermsChange?: boolean;
  handleEmailChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleEmailBlur?: () => void;
  email?: string;
  invalidEmail?: boolean;
  didEmailChange?: boolean;
  handlePayeeChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePayeeBlur?: () => void;
  payee?: string;
  invalidPayee?: boolean;
  didPayeeChange?: boolean;
  handleQTYChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleQTYBlur?: () => void;
  qTY?: string;
  invalidQTY?: boolean;
  didQTYChange?: boolean;
  handleRateChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRateBlur?: () => void;
  rate?: string;
  invalidRate?: boolean;
  didRateChange?: boolean;
  handleCommentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCommentBlur: () => void;
  comment: string;
  invalidComment: boolean;
  didCommentChange: boolean;
  handleLinkChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleLinkBlur: () => void;
  link: string;
  invalidLink: boolean;
  didLinkChange: boolean;
  handleSubjectChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubjectBlur: () => void;
  subject: string;
  invalidSubject: boolean;
  didSubjectChange: boolean;
  error: string;
  Priority: string[];
  selectedItems: {
    priority: string;
    status: string;
    related: { Name: string; Id: string }[];
    relatedType: string[];
    assignTo: { Name: string; Id: string }[];
    nameType: string[];
    name: { Name: string; Id: string }[];
    dueDate: string;
    payee: { Name: string; Id: string }[];
    terms: string[];
  };
  handleSelection: (item: any, type: string) => void;
  handleDeleteItems: (item: any, type: string) => void;
  onDrop: (acceptedFile: any) => void;
  selectedFiles: (File | string)[];
  add: () => void;
  deleteFile: (index: number) => void;
  selectedType: string;
  subTask?: {
    subject: string;
    comment: string;
    link: string;
  }[];
  setDate: React.Dispatch<React.SetStateAction<Dayjs | null>>;
  date: Dayjs | null;
  Status: string[];
  Assign: { Name: string; Id: string }[];
  edit: boolean;
  relatedTo: {
    account: {
      Name: string;
      Id: string;
    }[];

    deal: {
      Name: string;
      Id: string;
    }[];
  };

  name: {
    lead: {
      Name: string;
      Id: string;
    }[];
    contact: {
      Name: string;
      Id: string;
    }[];
  };
  formLoading: boolean;
  setFormLoading: React.Dispatch<React.SetStateAction<boolean>>;
  onClearError?: () => void;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const isXs = useMediaQuery(theme.breakpoints.down('xl'));
  const openInput = () => {
    window.document.getElementById('attachment')?.click();
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      onDrop(Array.from(event.target.files));
    }
  };
  const hasValidAssignee = selectedItems.assignTo?.some(
    (assignee) => assignee?.Id && assignee?.Name,
  );
  const [assigneeTouched, setAssigneeTouched] = useState(false);
  const assigneeError = isAssigneeError(error)
    ? error
    : !hasValidAssignee && assigneeTouched
      ? 'Please select an assignee'
      : '';
  const subjectFieldError =
    error && !isAssigneeError(error)
      ? error
      : invalidSubject && didSubjectChange
        ? 'Please enter valid Subject'
        : '';
  const disable =
    !subject || !hasValidAssignee || !selectedItems.priority || !selectedItems.status;

  const [relatedOptions, setRelatedOptions] = useState(
    relatedTo[
      (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
    ]?.slice(0, 5),
  );
  const [payeeOptions, setPayeeOptions] = useState(
    relatedTo['account' as keyof typeof relatedTo]?.slice(0, 5),
  );
  const [nameOptions, setNameOptions] = useState(
    name[(selectedItems.nameType[0].toLocaleLowerCase() || 'contact') as keyof typeof name]?.slice(
      0,
      5,
    ),
  );

  const handleRelatedFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = relatedTo[
        (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
      ]?.filter((e) => e.Name?.toLocaleLowerCase().includes(value?.toLocaleLowerCase()));
      setRelatedOptions(filter);
    } else {
      setRelatedOptions(
        relatedTo[
          (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
        ]?.slice(0, 5),
      );
    }
  };
  const handleNameFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = name[
        (selectedItems.nameType[0]?.toLocaleLowerCase() || 'contact') as keyof typeof name
      ]?.filter((e) => e.Name?.toLocaleLowerCase().includes(value?.toLocaleLowerCase()));
      setNameOptions(filter);
    } else {
      setNameOptions(
        name[
          (selectedItems.nameType[0]?.toLocaleLowerCase() || 'contact') as keyof typeof name
        ]?.slice(0, 5),
      );
    }
  };
  const handlePayeeFilter = (e: React.SyntheticEvent, value: string) => {
    if (value) {
      const filter = relatedTo['account' as keyof typeof relatedTo]
        ?.slice(0, 5)
        ?.filter((e) => e.Name?.toLocaleLowerCase().includes(value?.toLocaleLowerCase()));
      setPayeeOptions(filter);
    } else {
      setPayeeOptions(relatedTo['account' as keyof typeof relatedTo]?.slice(0, 5));
    }
  };
  const [initial, setInitial] = useState(
    edit || location?.pathname?.includes('clients')
      ? { related: true, name: true }
      : { related: false, name: false },
  );

  useEffect(() => {
    if (selectedItems?.relatedType[0] !== 'None') {
      setRelatedOptions(
        relatedTo[
          (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
        ]?.slice(0, 5),
      );
    } else {
      setRelatedOptions([]);
    }
    !initial?.related && handleSelection({ Name: '', Id: '' }, 'related');
    initial?.related && setInitial((prev) => ({ ...prev, related: false }));
  }, [selectedItems?.relatedType]);

  useEffect(() => {
    if (selectedItems?.nameType[0] !== 'None') {
      setNameOptions(
        name[
          (selectedItems.nameType[0]?.toLocaleLowerCase() || 'contact') as keyof typeof name
        ]?.slice(0, 5),
      );
    } else {
      setNameOptions([]);
    }
    if (selectedItems?.nameType[0]?.toLocaleLowerCase() === 'lead') {
      handleSelection({ Name: '', Id: '' }, 'related');
      handleSelection([''], 'relatedType');
    }
    !initial?.name && handleSelection({ Name: '', Id: '' }, 'name');
    initial?.name && setInitial((prev) => ({ ...prev, name: false }));
  }, [selectedItems?.nameType]);

  let totalRelatedLength =
    relatedTo[
      (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
    ]?.length;
  let totalPayeeLength = relatedTo['account' as keyof typeof relatedTo]?.length;
  let totalNameLength =
    name[(selectedItems.nameType[0]?.toLocaleLowerCase() || 'contact') as keyof typeof name]
      ?.length;

  let currentRelatedLength = useRef(0);
  let currentPayeeLength = useRef(0);
  let currentNameLength = useRef(0);

  const handleRelatedScroll = () => {
    setRelatedOptions([
      ...relatedTo[
        (selectedItems.relatedType[0]?.toLocaleLowerCase() || 'account') as keyof typeof relatedTo
      ]?.slice(0, currentRelatedLength.current + 5),
    ]);
    currentRelatedLength.current += 5;
  };
  const handlePayeeScroll = () => {
    setRelatedOptions([
      ...relatedTo['account' as keyof typeof relatedTo]?.slice(0, currentPayeeLength.current + 5),
    ]);
    currentPayeeLength.current += 5;
  };
  const handleNameScroll = () => {
    setNameOptions([
      ...name[
        (selectedItems.nameType[0]?.toLocaleLowerCase() || 'contact') as keyof typeof name
      ]?.slice(0, currentNameLength.current + 5),
    ]);
    currentNameLength.current += 5;
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '24px 24px 24px 24px',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
        }}
      >
        <CustomTextField
          style={{ width: '100%' }}
          onBlur={handleSubjectBlur}
          onChange={handleSubjectChange}
          name='Subject'
          text={subject}
          form={true}
          error={subjectFieldError}
          label={'Subject'}
          type='text'
          tabindex={1}
          required
        />
        <FormControl sx={{ width: '100%' }}>
          <AssigneeAutocomplete
            value={selectedItems?.assignTo || []}
            onChange={(newValue) => {
              setAssigneeTouched(true);
              const assignees = Array.isArray(newValue) ? newValue : newValue ? [newValue] : [];
              const validAssignees = assignees.filter(
                (assignee: any) => assignee && assignee.Id && assignee.Name,
              );
              handleSelection(validAssignees, 'assignTo');
              if (validAssignees.length > 0) {
                onClearError?.();
              }
            }}
            multiple={true}
            required={true}
            label='Assign to'
            error={assigneeError}
            onClose={() => setAssigneeTouched(true)}
          />
        </FormControl>

        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Name type
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              value={
                typeof selectedItems.nameType == 'string'
                  ? selectedItems.nameType
                  : selectedItems.nameType[0]
              }
              onChange={(e) => handleSelection(e, 'nameType')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Name type'
                />
              }
              renderValue={(selected) => {
                return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {[...Object.keys(name), 'None'].map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.nameType.indexOf(name) > -1}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />

                  {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }}>
            <CustomAutocomplete
              options={nameOptions || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Name'}
              handleDeleteItems={handleDeleteItems}
              selectedItems={selectedItems}
              handleSelection={(value) => {
                handleSelection(value, 'name');
              }}
              multiple={false}
              value={selectedItems?.name[0]}
              handleFilter={handleNameFilter}
              placeholder='Search name'
              currentLength={nameOptions?.length}
              totalLength={totalNameLength}
              next={handleNameScroll}
              disabled={selectedItems?.nameType[0] ? false : true}
            />
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
              }}
            >
              Related type
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              disabled={selectedItems?.nameType[0] === 'lead'}
              value={
                typeof selectedItems.relatedType == 'string'
                  ? selectedItems.relatedType
                  : selectedItems.relatedType[0]
              }
              onChange={(e) => handleSelection(e, 'relatedType')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Related type'
                />
              }
              renderValue={(selected) => {
                return `${selected.slice(0, 1).toLocaleUpperCase()}${selected.slice(1)}`;
              }}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {[...Object.keys(relatedTo), 'None'].map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={selectedItems.relatedType.indexOf(name) > -1}
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }}>
            <CustomAutocomplete
              options={relatedOptions || []}
              getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
              label={'Related To'}
              disabled={selectedItems?.nameType[0] === 'lead' || !selectedItems?.relatedType[0]}
              handleDeleteItems={handleDeleteItems}
              selectedItems={selectedItems}
              handleSelection={(value) => {
                handleSelection(value, 'related');
              }}
              multiple={false}
              value={selectedItems.related[0]}
              handleFilter={handleRelatedFilter}
              placeholder={`Search ${selectedItems.relatedType[0] ?? 'account'}`}
              currentLength={relatedOptions?.length || 0}
              totalLength={totalRelatedLength}
              next={handleRelatedScroll}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <CustomDatePicker value={date} setValue={setDate} />
          {selectedType === 'Payment Task' && (
            <Box sx={{ width: '100%' }}>
              <CustomAutocomplete
                options={payeeOptions}
                getOptionLabel={(option: any) => (option?.Name ? option?.Name : '')}
                label={'Payee'}
                disabled={false}
                handleDeleteItems={handleDeleteItems}
                selectedItems={selectedItems}
                handleSelection={(value) => {
                  handleSelection(value, 'payee');
                }}
                multiple={false}
                value={selectedItems.payee[0]}
                handleFilter={handlePayeeFilter}
                placeholder={`Search payee`}
                currentLength={payeeOptions?.length}
                totalLength={totalPayeeLength}
                next={handlePayeeScroll}
              />
            </Box>
          )}
        </Box>
        {selectedType === 'Payment Task' && (
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleQTYBlur && handleQTYBlur();
              }}
              form={true}
              onChange={(e) => {
                handleQTYChange && handleQTYChange(e);
              }}
              name={'QTY'}
              text={qTY ? qTY : ''}
              error={invalidQTY && didQTYChange ? 'Please enter valid QTY' : ''}
              label={'QTY'}
              type='number'
              tabindex={1}
            />

            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleRateBlur && handleRateBlur();
              }}
              form={true}
              onChange={(e) => {
                handleRateChange && handleRateChange(e);
              }}
              name={'Rate'}
              text={rate ? `${rate}` : ''}
              error={invalidRate && didRateChange ? 'Please enter valid rate' : ''}
              label={'Rate'}
              type='number'
              tabindex={1}
            />
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
          <FormControl sx={{ width: '100%' }} required>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              required
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
                '& .MuiFormLabel-asterisk': { color: zeplinColor.Error },
              }}
            >
              Status
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              required
              value={selectedItems.status}
              onChange={(e) => handleSelection(e, 'status')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Status'
                />
              }
              renderValue={(selected) => (
                <Chip
                  label={<Typography variant='label1'>{selected}</Typography>}
                  sx={{
                    bgcolor:
                      Constants.StatusTask[
                        (selected || 'To Do') as 'To Do' | 'In Progress' | 'Done'
                      ],
                    color: zeplinColor.Neutral1,
                    '&.MuiChip-root': {
                      height: '29px',
                      padding: '4px 14px',
                      borderRadius: '50px',
                    },
                    '& .MuiChip-label': {
                      padding: 0,
                    },
                  }}
                />
              )}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {Status.map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={
                      Array.isArray(selectedItems.status)
                        ? selectedItems.status.indexOf(name) > -1
                        : selectedItems.status === name
                    }
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ width: '100%' }} required>
            <InputLabel
              id='demo-multiple-name-label'
              size={isXs ? 'small' : 'medium'}
              required
              sx={{
                '&.Mui-focused': { color: zeplinColor.Neutral9 },
                fontSize: isXs ? 14 : 16,
                '& .MuiFormLabel-asterisk': { color: zeplinColor.Error },
              }}
            >
              Priority
            </InputLabel>
            <Select
              labelId='demo-multiple-name-label'
              id='demo-multiple-name'
              size={isXs ? 'small' : 'medium'}
              required
              value={selectedItems.priority}
              onChange={(e) => handleSelection(e, 'priority')}
              input={
                <OutlinedInput
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '1px',
                      color: zeplinColor.Neutral9,
                      borderColor: zeplinColor.Neutral9,
                    },
                  }}
                  label='Priority'
                />
              }
              renderValue={(selected) => (
                <Chip
                  label={<Typography variant='label1'>{selected}</Typography>}
                  sx={{
                    bgcolor:
                      Constants.PriorityTask[(selected || 'Medium') as 'Normal' | 'Low' | 'High'] ||
                      Constants.PriorityTask.Normal,
                    color: zeplinColor.Neutral1,
                    '&.MuiChip-root': {
                      height: '29px',
                      padding: '4px 14px',
                      borderRadius: '50px',
                    },
                    '& .MuiChip-label': {
                      padding: 0,
                    },
                  }}
                />
              )}
              MenuProps={MenuProps}
              IconComponent={KeyboardArrowDown}
            >
              {Priority.map((name) => (
                <MenuItem key={name} value={name}>
                  <Radio
                    checked={
                      Array.isArray(selectedItems.priority)
                        ? selectedItems.priority.indexOf(name) > -1
                        : selectedItems.priority === name
                    }
                    sx={{
                      color: zeplinColor.BasicBlack,
                      '&.Mui-checked': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {selectedType === 'Payment Task' && (
          <Box sx={{ display: 'flex', gap: '24px', width: '100%' }}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel
                id='demo-multiple-name-label'
                size={isXs ? 'small' : 'medium'}
                sx={{
                  '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  fontSize: isXs ? 14 : 16,
                }}
              >
                Terms
              </InputLabel>
              <Select
                labelId='demo-multiple-name-label'
                id='demo-multiple-name'
                value={selectedItems?.terms}
                onChange={(e) => handleSelection(e, 'terms')}
                input={
                  <OutlinedInput
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        color: zeplinColor.Neutral9,
                        borderColor: zeplinColor.Neutral9,
                      },
                    }}
                    label='Related type'
                  />
                }
                renderValue={(selected) =>
                  `${selected[0].slice(0, 1).toLocaleUpperCase()}${selected[0].slice(1)}`
                }
                MenuProps={MenuProps}
                IconComponent={KeyboardArrowDown}
              >
                {['Net 30', 'Net 60', 'Net 90', 'None'].map((name) => (
                  <MenuItem key={name} value={name}>
                    <Radio
                      checked={selectedItems.relatedType.indexOf(name) > -1}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '&.Mui-checked': {
                          color: zeplinColor.BasicBlack,
                        },
                      }}
                    />
                    {`${name.slice(0, 1).toLocaleUpperCase()}${name.slice(1)}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={() => {
                handleEmailBlur && handleEmailBlur();
              }}
              form={true}
              onChange={(e) => {
                handleEmailChange && handleEmailChange(e);
              }}
              name={'Email'}
              text={email ? email : ''}
              error={invalidEmail && didEmailChange ? 'Please enter valid email' : ''}
              label={'Email'}
              type='text'
              tabindex={1}
            />
          </Box>
        )}
        <CustomTextField
          style={{ width: '100%' }}
          onBlur={handleCommentBlur}
          onChange={handleCommentChange}
          name='Comments'
          text={comment}
          form={true}
          error={invalidComment && didCommentChange ? 'Please enter valid Comment' : ''}
          label={'Description'}
          type='text'
          tabindex={1}
          multiline
        />
        <CustomTextField
          style={{ width: '100%' }}
          form={true}
          onBlur={handleLinkBlur}
          onChange={handleLinkChange}
          name='Link'
          text={link}
          error={invalidLink && didLinkChange ? 'Please enter valid Link' : ''}
          label={'Link'}
          type='text'
          tabindex={1}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
              <img
                className={styles.icon}
                src={'/assets/attachment.svg'}
                alt='logo'
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                Attachment
              </Typography>
            </Box>

            {selectedFiles?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  width: '100%',
                  alignItems: 'center',
                  flex: 1,
                  justifyContent: 'flex-end',
                  cursor: 'pointer',
                }}
                onClick={openInput}
              >
                <input
                  type='file'
                  id='attachment'
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
                <img
                  width={'24px'}
                  height={'24px'}
                  src={'/assets/upload-blue.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
                <Typography variant='buttonMedium' color={zeplinColor.Brand1}>
                  Select File
                </Typography>
              </Box>
            ) : (
              ''
            )}
          </Box>
          {!selectedFiles?.length ? (
            <CustomDragnDrop onDrop={onDrop} />
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {selectedFiles.map((file: File | string, index: number) => {
                const filePath = file instanceof File ? file.name : String(file);
                const fileName = file instanceof File ? file.name : filePath;
                const fileExtension = fileName.split('.').pop()?.toLowerCase() || 'file';
                const displayName =
                  file instanceof File
                    ? file.name
                    : filePath.includes('|')
                      ? filePath.split('|')[1].split('/').pop() || fileName
                      : fileName.split('/').pop() || fileName;

                return (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '12px',
                    }}
                  >
                    <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                      <img
                        width={'40px'}
                        height={'40px'}
                        src={`/assets/${fileExtension}.svg`}
                        alt='file-type'
                        style={{ objectFit: 'fill' }}
                      />
                      <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                        <LightTooltip
                          title={
                            <Typography variant='body3' color={zeplinColor.Neutral1}>
                              {displayName}
                            </Typography>
                          }
                          placement='bottom-end'
                          style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                        >
                          <Typography variant='body2'>
                            {displayName.slice(0, 40)}
                            {displayName.length > 40 && '...'}
                          </Typography>
                        </LightTooltip>
                        {file instanceof File && (
                          <Typography variant='label1'>{file.size / 10000}MB</Typography>
                        )}
                      </Box>
                    </Box>
                    <img
                      width={'24px'}
                      height={'24px'}
                      src={'/assets/delete-blue.svg'}
                      alt='logo'
                      style={{ objectFit: 'fill', cursor: 'pointer' }}
                      onClick={() => deleteFile(index)}
                    />
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          bottom: '0px',
          margin: 'auto',
          zIndex: '100',
          padding: '24px',
          backgroundColor: zeplinColor.Neutral1,
        }}
      >
        <CustomButton
          disabled={disable || formLoading}
          onClick={add}
          variant='contained'
          color={disable ? 'customDisable' : 'primary'}
          style={{
            borderRadius: '14px',
            height: 56,
            width: '100%',
            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
          }}
          textStyle={{ color: disable ? zeplinColor.Neutral8 : zeplinColor.Neutral1 }}
          text={
            subtask
              ? !formLoading
                ? 'Add Subtask'
                : 'Adding Subtask'
              : edit
                ? !formLoading
                  ? 'Save'
                  : 'Saving'
                : !formLoading
                  ? 'Create Task'
                  : 'Creating Task'
          }
        />
      </Box>
    </>
  );
};

export default CustomAddTaskForm;
